import { useEffect, useState } from 'react';

// Debounced here rather than in the query hook, so typing stays instant and only the search waits.
export const useDebouncedValue = <TValue>(value: TValue, delayMs: number): TValue => {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSettled(value);
    }, delayMs);

    // Every keystroke cancels the pending one, so only the last value lands.
    return (): void => {
      clearTimeout(timer);
    };
  }, [value, delayMs]);

  return settled;
};
